import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { useIsFramed } from 'site-modules/shared/hooks/use-is-framed';

function CanvasLocationSyncUI({ zipCode = null, iframeRef = null, setModelValue, isIframeLogic = false }) {
  const isFramed = useIsFramed();

  useEffect(() => {
    if (isIframeLogic && isFramed) {
      window?.parent?.postMessage({ zipCode }, window.location.origin);
    }
  }, [zipCode, isFramed, isIframeLogic]);

  useEffect(() => {
    if (isIframeLogic) {
      return noop;
    }

    function onMessage(event) {
      if (event.source === iframeRef?.current?.contentWindow && event?.data?.zipCode) {
        setModelValue('location', VisitorModel, { zipCode: event.data.zipCode });
      }
    }

    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIframeLogic]);

  return null;
}

CanvasLocationSyncUI.propTypes = {
  setModelValue: PropTypes.func.isRequired,
  iframeRef: PropTypes.shape({ current: PropTypes.shape() }),
  zipCode: PropTypes.string,
  isIframeLogic: PropTypes.bool,
};

export const CanvasLocationSync = connectToModel(CanvasLocationSyncUI, {
  zipCode: bindToPath('location.zipCode', VisitorModel),
});
